/**
 * Copyright © Scandiweb, Inc. All rights reserved.
 *
 * @category    Puma
 * @package     Puma_Subscription
 * @author      Deniss Strombergs <info@scandiweb.com>
 */

import PropTypes from 'prop-types';
import React, { createRef, PureComponent } from 'react';
import { connect } from 'react-redux';

import SubscriptionQuery from 'Query/Subscription.query';
import { toggleOverlayByKey } from 'Store/Overlay/Overlay.action';
import { showPopup } from 'Store/Popup/Popup.action';
import { fetchMutation } from 'Util/Request';

import SubscriptionComponent from './Subscription.component';

/** @namespace Scandipwa/Component/Subscription/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    toggleOverlayByKey: (key) => dispatch(toggleOverlayByKey(key)),
    showPopup: (payload) => dispatch(showPopup('title', payload))
});

/** @namespace Scandipwa/Component/Subscription/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    subscriptionPopupTerms: state.ConfigReducer.subscriptionPopupTerms,
    activeOverlay: state.OverlayReducer.activeOverlay
});

/** @namespace Scandipwa/Component/Subscription/Container */
export class SubscriptionContainer extends PureComponent {
    static propTypes = {
        showPopup: PropTypes.func.isRequired,
        subscriptionPopupTerms: PropTypes.string.isRequired,
        activeOverlay: PropTypes.string.isRequired,
        toggleOverlayByKey: PropTypes.func.isRequired
    };

    containerFunctions = {
        subscribe: this.subscribe.bind(this)
    };

    subscribeEmailRef = createRef();

    containerProps() {
        const {
            showPopup,
            subscriptionPopupTerms,
            toggleOverlayByKey,
            activeOverlay
        } = this.props;

        return {
            showPopup,
            subscribeEmailRef: this.subscribeEmailRef,
            subscriptionPopupTerms,
            toggleOverlayByKey,
            activeOverlay
        };
    }

    subscribe(email, response) {
        const requestField = SubscriptionQuery.getSubscriptionEmailQuery(email);

        fetchMutation(requestField).then(
            /** @namespace Scandipwa/Component/Subscription/Container/SubscriptionContainer/subscribe/fetchMutation/then */
            ({ addEmailToSubscription }) => {
                response(addEmailToSubscription);
            },
            /** @namespace Scandipwa/Component/Subscription/Container/SubscriptionContainer/subscribe/fetchMutation/then/catch */
            ([{ message }]) => {
                response(message);
            }
        );
    }

    render() {
        return (
            <SubscriptionComponent
              { ...this.containerProps() }
              { ...this.containerFunctions }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionContainer);
